import React, { useState, useEffect, useMemo, useCallback } from "react";
import Footer from "../Footer/Footer";
import axios from "axios";

const MyOrders = () => {
  const [orderData, setOrderData] = useState([]);
  const [delBoyData, setDelBoyData] = useState([]);
  const [orderType, setOrderType] = useState("Current");
  const [activeAccordionIndex, setActiveAccordionIndex] = useState(null); // Track expanded accordion

  const loginDetails = JSON.parse(localStorage.getItem("loginDetails") || "{}");
  const API_BASE_URL = process.env.REACT_APP_API_KEY;

  const storedData = JSON.parse(localStorage.getItem("outletdataLocal")) || {};
  const outletId = Array.isArray(storedData) ? storedData[0]?.outletId : storedData?.outletId;
  const outletlogo = Array.isArray(storedData) ? storedData[0]?.outletlogo : storedData?.outletlogo;
  const outletName = Array.isArray(storedData) ? storedData[0]?.outletName : storedData?.outletName;

  const getOrderData = useCallback(async () => {
    if (!loginDetails?.customerId) return;

    try {
      const apiUrl =
        orderType == "Current"
          ? `${API_BASE_URL}QrOrder/GetCurrentOrdersByCustomerId?customerId=${loginDetails.customerId}`
          : `${API_BASE_URL}QrOrder/GetHistoryOrdersByCustomerId?customerId=${loginDetails.customerId}`;

      const response = await axios.get(apiUrl);
      const orders = response.data || []; // Ensure it's at least an empty array
     
      if (Array.isArray(orders) && orders.length > 0) {
        setOrderData(orders);
         // or setCurrentOrders / setHistoryOrders based on orderType
      } else {
        setOrderData([]); // No orders found
      }

    } catch (error) {
      console.error("Error fetching orders:", error);
      setOrderData([]); // Set to empty array on error to prevent UI crash
    }

  }, [loginDetails.customerId, orderType, API_BASE_URL]);

  useEffect(() => {
    getOrderData(); // Fetch immediately

    const interval = setInterval(() => {
      getOrderData();
    }, 30000); // Call every 60 seconds

    return () => clearInterval(interval); // Cleanup on unmount
  }, [getOrderData]);


  const statusMap = useMemo(
    () => ({
      1: "Placed",
      2: "Accepted",
      3: "Ready",
      4: "Pickup",
      5: "Delivered",
      6: "Paid",
      7: "Cancelled",
    }),
    []
  );

  const statusColors = useMemo(
    () => ({
      1: "#FAA0A0",
      2: "#F0A04B",
      3: "#FDFD96",
      4: "#779ECB",
      5: "#B7B1F2",
      6: "#77DD77",
      7: "#c90d0a",
    }),
    []
  );

  const toggleAccordion = (index) => {
    setActiveAccordionIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    <>
      <nav className="navbar navbar-light bg-light sticky-top">
        <div className="container-fluid">
          <b className="navbar-brand me-3">
            {outletlogo && <img className="me-4" src={outletlogo} width={60} height={40} alt="Outlet Logo" />}
            <strong className="mt-5">{outletName}</strong>
          </b>
        </div>
      </nav>

      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="col-10 d-flex mb-2 justify-content-between" style={{ marginLeft: "30px" }}>
              {["Current", "History"].map((type) => (
                <div className="form-check" key={type}>
                  <input
                    className="form-check-input"
                    type="radio"
                    name="orderType"
                    checked={orderType == type}
                    onChange={() => setOrderType(type)}
                  />
                  <label className="form-check-label">{type} Orders</label>
                </div>
              ))}
            </div>
            <div className="d-flex justify-content-between">
              <div className="legend mb-2 text-center" style={{ height: "20px", width: "60px", backgroundColor: "#FAA0A0", fontSize: "12px" }}>Placed</div>
              <div className="legend mb-2 text-center" style={{ height: "20px", width: "60px", backgroundColor: "#F0A04B", fontSize: "12px" }}>Accepted</div>
              <div className="legend mb-2 text-center" style={{ height: "20px", width: "60px", backgroundColor: "#FDFD96", fontSize: "12px" }}>Ready</div>
              <div className="legend mb-2 text-center" style={{ height: "20px", width: "60px", backgroundColor: "#779ECB", fontSize: "12px" }}>PickUp</div>
              <div className="legend mb-2 text-center" style={{ height: "20px", width: "60px", backgroundColor: "#B7B1F2", fontSize: "12px" }}>Delivered</div>

            </div>

            {orderData.length > 0 ? (
              <div className="accordion">
                {orderData.map((order, index) => (
                  <div className="accordion-item" key={order.orderId || index}>
                    <h2 className="accordion-header" id={`heading${index}`}>
                      <button
                        className={`accordion-button p-1 ${activeAccordionIndex === index ? "" : "collapsed"}`}
                        style={{
                          border: "0.5px solid black",
                          backgroundColor:
                            statusColors[order?.onlineOrderStatusDetails?.[0]?.orderStatus] || "white",
                        }}
                        type="button"
                        onClick={() => toggleAccordion(index)}
                      >
                        <div className="container-fluid w-100 p-0">
                          <div className="row">
                            <div className="col-md-12 d-flex justify-content-between"
                              style={{ fontSize: "12Px" }}
                            >
                              <p className="m-0">
                                <strong>ID:</strong> {order.orderId}
                              </p>
                              <p className="m-0">
                                <strong>DelBoy : </strong>
                                {order.deliveryDetail.shortName || "Unknown"}
                              </p>
                              <p className="m-0">
                                <strong>Mob</strong>{" "}
                                {order.deliveryDetail.contactNo || "Unknown"}
                              </p>
                            </div>

                          </div>
                        </div>
                      </button>
                    </h2>
                    <div
                      id={`collapse${index}`}
                      className={`accordion-collapse collapse ${activeAccordionIndex === index ? "show" : ""}`}
                      aria-labelledby={`heading${index}`}
                    >
                      <div className="accordion-body">
                        <div className="col-12 mt-2">
                          <table className="table table-bordered">
                            <thead className="thead-light">
                              <tr>
                                <th>Code</th>
                                <th>Item Name</th>
                                <th>Rate</th>
                                <th>Qty</th>
                                <th>Amt</th>
                              </tr>
                            </thead>
                            <tbody>
                              {order.orderDetails?.map((item, idx) => (
                                <tr key={idx}>
                                  <td>{item.rmsItemId}</td>
                                  <td>{item.qrItemName}</td>
                                  <td className="text-end">{item.rate}</td>
                                  <td className="text-end">{item.quantity}</td>
                                  <td className="text-end">{item.amount}</td>
                                </tr>
                              ))}
                            </tbody>
                            <tfoot>
                              <tr>
                                <td colSpan="4" className="text-end p-1">
                                  Item Amount
                                </td>
                                <td className="p-1 text-end">
                                  {order.orderDetails?.reduce((sum, item) => sum + item.amount, 0).toFixed(2) || 0}
                                </td>
                              </tr>
                              <tr>
                                <td colSpan="4" className="text-end p-1 ">
                                  CGST
                                </td>
                                <td className="p-1 text-end">
                                  {order.billDetail.cgst.toFixed(2)}
                                </td>
                              </tr>
                              <tr>
                                <td colSpan="4" className="text-end p-1">
                                  SGST
                                </td>
                                <td className="p-1 text-end">
                                  {order.billDetail.sgst.toFixed(2)}
                                </td>
                              </tr>
                              <tr>
                                <td colSpan="4" className="text-end p-1">
                                  Delivery Charges
                                </td>
                                <td className="p-1 text-end">
                                  {order.billDetail.orderDeliveryCharges.toFixed(2)}
                                </td>
                              </tr>
                              <tr className="p-1">
                                <td colSpan="4" className="text-end ">
                                  round Off
                                </td>
                                <td className="p-1 text-end">
                                  {order.billDetail.roundOff.toFixed(2)}
                                </td>
                              </tr>
                              <tr>
                                <td colSpan="4" className="text-end fw-bold p-1">
                                  Total Amount
                                </td>
                                <td className="fw-bold p-1 text-end">
                                  {
                                    (
                                      (order.orderDetails?.reduce((sum, item) => sum + item.amount, 0) || 0) +
                                      (order.billDetail.cgst || 0) +
                                      (order.billDetail.sgst || 0) +
                                      (order.billDetail.orderDeliveryCharges || 0) -
                                      (order.billDetail.roundOff || 0)
                                    ).toFixed(2)
                                  }
                                </td>
                              </tr>

                            </tfoot>
                          </table>
                          
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p>No {orderType} orders available.</p>
            )}
          </div>
        </div>
      </div>

      <div className="fixed-bottom p-0">
        <Footer />
      </div>
    </>
  );
};

export default MyOrders;
